import { DataBean } from "../DataBean";

export class StatementMovementCatalog extends DataBean {


    public async getBankingStatementMovementCatalog(idBankingStatement: number, state: number, page: number, recordsPerPage: number ): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.advantage.shared.Report_getBankingStatementMovementCatalog_Number_Number_Number_Number", [idBankingStatement,state, page, recordsPerPage]);
    }

     public async updateBankingStatement(bean:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "void_updateBankingStatementMovement_com.quickdataerp.bean.documents.BankingStatementMovement", [
            {
                DataBeanProperties:bean,
                DataBeanName:"com.quickdataerp.bean.documents.BankingStatementMovement"
            }
        ]);
    }

}